<admin-header [title]="title"></admin-header>
<dx-data-grid class="data-grid" [dataSource]="audits" [remoteOperations]="false" [allowColumnReordering]="true" [allowColumnResizing]="true" [rowAlternationEnabled]="true" [showBorders]="true" (onExporting)="logExport()">
    <dxo-paging [pageSize]="100"></dxo-paging>
	<dxo-state-storing [enabled]="true" type="localStorage" storageKey="auditMain"></dxo-state-storing>
    <dxo-pager [visible]="true" [showPageSizeSelector]="true" [allowedPageSizes]="[10, 25, 50, 100]"></dxo-pager>
    <dxo-search-panel [visible]="true" [highlightCaseSensitive]="true"></dxo-search-panel>
    <dxo-group-panel [visible]="true"></dxo-group-panel>
    <dxo-grouping [autoExpandAll]="false"></dxo-grouping>
	<dxo-export [enabled]="canExportGrid"></dxo-export>
	<dxo-scrolling columnRenderingMode="virtual"></dxo-scrolling>
	<dxi-column type="buttons">
        <dxi-button hint="View" icon="fal fa-eye" [onClick]="viewRow"></dxi-button>
    </dxi-column>
    <dxi-column dataField="createdAt" dataType="date" format="dd/MM/yyy" alignment="left"></dxi-column>
	<dxi-column dataField="detail.Table" dataType="string" alignment="left"></dxi-column>
	<dxi-column dataField="detail.Action" dataType="string" alignment="left"></dxi-column>
    <dxi-column dataField="userId" dataType="string" alignment="left"></dxi-column>	
</dx-data-grid>